import * as Scrivito from "scrivito";
import PlaceholderOrYoutube from "./PlaceholderOrYoutube";
import PlaceholderOrVimeo from "./PlaceholderOrVimeoComponent";

const ImageOrVideo = ({
  widget,
  teaser,
  className = "img-fluid",
  lazy = true,
}) => {
  if (!widget) {
    return null;
  }

  const videoUrl = widget.get("video");
  const videoObj = widget.get("videoObject");

  if (videoObj) {
    return (
      <video
        src={Scrivito.urlFor(videoObj)}
        autoPlay={true}
        muted={true}
        controls={false}
        loop={true}
        playsInline
        className="w-100"
      />
    );
  }

  if (videoUrl?.startsWith("https://www.youtube.com/")) {
    return (
      <PlaceholderOrYoutube videoUrl={widget.get("video")} teaser={teaser} />
    );
  }

  if (videoUrl?.startsWith("https://vimeo.com/")) {
    return (
      <PlaceholderOrVimeo videoUrl={widget.get("video")} teaser={teaser} />
    );
  }

  return (
    <Scrivito.ImageTag
      content={widget}
      attribute="image"
      className={`${className}`}
      alt={widget.get("image")?.get("alternativeText")}
      loading={lazy ? "lazy" : "eager"}
      fetchPriority={!lazy ? "high" : undefined}
      width={widget.get("image")?.metadata().get("width")}
      height={widget.get("image")?.metadata().get("height")}
    />
  );
};

export default Scrivito.connect(ImageOrVideo);
